import React from 'react'
import { Typography, useMediaQuery, useTheme } from '@mui/material'
import ScreenContainerMain from '~shared/components/ScreenContainerMain'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useTranslation } from 'react-i18next'
import SpareAxleRequestFormWizard from '~app/screens/SpareAxleRequest/components/SpareAxleRequestFormWizard'
import clsx from 'clsx'

const SpareAxleRequest: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return <ScreenContainerMain>
    <Typography variant='h2' component='h1' className={clsx(gs.marginBottomSmall)} style={isMobile ? {} : { paddingLeft: '80px' }}>
      {t('common:navHeaderSpareAxleRequest')}
    </Typography>
    <SpareAxleRequestFormWizard />
  </ScreenContainerMain>
}
export default SpareAxleRequest
